import { useNavigate } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import Iconify from '@/components/iconify/index.tsx';
import { usePickemStore } from '@/store/usePickem.store.ts';
import { useUpdateQuestionMutation } from '@/api/pickem-questions/updateQuestion.ts';
import { useEffect } from 'react';
import { useAppSearchParams } from '@/hooks/useAppSearchParams.ts';

interface QuestionsButtonsProps {
  form: any;
}

export const QuestionsButtons = ({ form }: QuestionsButtonsProps) => {
  const navigate = useNavigate();
  const { pickemId } = useAppSearchParams();
  const { isOrderingMode, setIsOrderingMode, isScoringMode, setIsScoringMode } =
    usePickemStore();

  useEffect(() => {
    return () => {
      setIsScoringMode(false);
      setIsOrderingMode(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { mutateAsync } = useUpdateQuestionMutation();

  const updateQuestions = () => {
    let questionUpdatePromises = [];

    const questions = form.getFieldValue('questions');

    for (let i = 0; i < questions.length; i++) {
      let question = questions[i];
      questionUpdatePromises.push(mutateAsync({ pickemId, question }));
    }

    Promise.all(questionUpdatePromises)
      .then(() => window.location.reload())
      .catch((error) => console.log('Update questions ERROR', error));
  };

  return (
    <Box>
      {!isScoringMode && !isOrderingMode && (
        <>
          <Button
            variant='outlined'
            startIcon={<Iconify icon='eva:toggle-left-outline' />}
            onClick={() => setIsScoringMode(true)}
            sx={{ mr: 2 }}
          >
            Scoring Mode
          </Button>
          <Button
            variant='outlined'
            startIcon={<Iconify icon='eva:toggle-left-outline' />}
            onClick={() => setIsOrderingMode(true)}
            sx={{ mr: 2 }}
          >
            Re-Ordering Mode
          </Button>
          <Button
            variant='contained'
            startIcon={<Iconify icon='eva:plus-outline' />}
            onClick={() =>
              navigate(`/dashboard/pickem/question?pickem_id=${pickemId}`)
            }
          >
            Create Question
          </Button>
        </>
      )}
      {isScoringMode && (
        <>
          <Button
            variant='outlined'
            startIcon={<Iconify icon='eva:close-outline' />}
            onClick={() => setIsScoringMode(false)}
            sx={{ mr: 2 }}
          >
            Cancel
          </Button>
          <Button
            variant='outlined'
            startIcon={<Iconify icon='eva:save-outline' />}
            onClick={updateQuestions}
            sx={{ mr: 2 }}
          >
            Update Questons
          </Button>
        </>
      )}
      {isOrderingMode && (
        <>
          <Button
            variant='outlined'
            startIcon={<Iconify icon='eva:close-outline' />}
            onClick={() => setIsOrderingMode(false)}
            sx={{ mr: 2 }}
          >
            Cancel
          </Button>
          <Button
            variant='outlined'
            startIcon={<Iconify icon='eva:save-outline' />}
            onClick={updateQuestions}
            sx={{ mr: 2 }}
          >
            Save Order
          </Button>
        </>
      )}
    </Box>
  );
};
